export class Warning {

    rowId: number; 
    message: string; 
    type?: number;

    constructor() {
    }
}